import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row
} from 'reactstrap';
import Card from '../../shared/Card';
import styles from './styles.scss';
import Select from '../../shared/Select';

class SelectLayout extends React.Component {
  constructor(props) {
    super(props);
  }

  static get propTypes() {
    return {
      selectedLayout: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      editMode: PropTypes.bool,
      layouts: PropTypes.array,
      onChange: PropTypes.func
    }
  }

  render() {
    const {
      selectedLayout,
      editMode,
      layouts,
      onChange
    } = this.props;

    return (
      <Card header='Selected Layout'>
        <Container>
          <If condition={!editMode}>
            <label className={`d-block ${styles.label}`}>{selectedLayout && selectedLayout.displayName ? selectedLayout.displayName : '-'}</label>
          </If>
          <If condition={!!editMode}>
          <Select options={layouts ? layouts.map((value, index) => {
              return {
                label: value.displayName,
                value: value
              } 
            }) : []}
            value={selectedLayout ? selectedLayout : ''}
            editMode={true}
            onChange={onChange}
          />
          </If>
        </Container>
      </Card>
    );
  }
}

export default SelectLayout;



// WEBPACK FOOTER //
// src/components/dynamicTestDetails/SelectLayout/index.jsx